import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { IonicPageModule } from "ionic-angular";
import { CommonComponentsModule } from "../../../components/common/common-components.module";
import { CertificationReceivedModal } from "./certification-received";

@NgModule({
  declarations: [CertificationReceivedModal],
  imports: [
    CommonComponentsModule,
    TranslateModule.forChild(),
    IonicPageModule.forChild(CertificationReceivedModal),
  ],
})
export class CertificationReceivedModule {}



// WEBPACK FOOTER //
// ./src/certification/forms/certification-received/certification-received.module.ts